import {Component} from '@angular/core';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {environment} from 'src/environments/environment';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  imports: [
    TranslatePipe
  ],
  styleUrls: ['./home.component.css']
})
export class HomeComponent {
  readonly VERSION = environment.VERSION;

  constructor(public translate: TranslateService) {
  }
}
